import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { AuthService } from '@core/auth.service'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class HasLicenceGuard implements CanActivate {
   constructor(
      private _router: Router,
      private _authService: AuthService
   ) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this._authService.hasLicence()
   }
}

@Injectable({ providedIn: 'root' })
export class HasNoLicenceGuard implements CanActivate {
   constructor(
      private _router: Router,
      private _authService: AuthService
   ) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (!this._authService.hasLicence()) {
         return true
      } else {
         this._router.navigate(['/'])
         return false
      }
   }
}

